
import Vue from "vue";
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {BvTableFieldArray} from "bootstrap-vue";
import {CargoOperationModel, CargoOperationType} from "@/api-client";
import {formatDate} from "@/formatting/dateFormatter";
import ConfirmModal from "@/features/shared/components/ConfirmModal.vue";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";

@Component({
    components: { 
        ConfirmModal,
        ButtonWithConfirm 
    }
})
export default class CargoOperationsTable extends Vue {
  @Prop({ required: true })
  value!: CargoOperationModel[];
  
  @Prop({ default: () => true })
  operationsCanBeRemoved!: boolean;
  
  private removeCargoOperation(cargoOperation: CargoOperationModel) {
    this.$emit('remove', cargoOperation);
  }
  
  private translateCargoOperationType(type: CargoOperationType) {
    switch(type) {
      case CargoOperationType.Loading:
        return this.$ls.Documents_Practices_CargoOperationType_Loading;
      case CargoOperationType.Unloading:
        return this.$ls.Documents_Practices_CargoOperationType_Unloading;
      default:
        return type;
    }
  }

  fields: BvTableFieldArray = [
    { key: 'nr', label: this.$ls.Documents_Practices_Table_CargoOperations_Label_Number, sortable: true, formatter: (value: any, key: any, item: CargoOperationModel) => {return this.value.indexOf(item) + 1}},
    { key: 'harbour', label: this.$ls.Documents_Practices_Table_CargoOperations_Label_Harbour, sortable: true, sortByFormatted: true, formatter: (value: string, key: string, item: CargoOperationModel) => item.harbour?.text },
    { key: 'date', label: this.$ls.Documents_Practices_Table_CargoOperations_Label_Date, sortable: true, formatter: (dateString: string, key: string, item: CargoOperationModel) => formatDate(item.date) },
    { key: 'type', label: this.$ls.Documents_Practices_Table_CargoOperations_Label_Type, sortable: true, sortByFormatted: true, formatter: (value: string, key: string, item: CargoOperationModel) => this.translateCargoOperationType(item.type!) },
    { key: 'actions', label: '', sortable: false, tdClass: 'table-actions' }
  ];
}
